/**
 * support.js
 *
 * Single point for the "support the project" link: the address to open, and
 * what the application is allowed to say about it on the platform it runs on.
 *
 * Apple treats a tip jar for a non-charitable app as a digital purchase, and a
 * button sending the diver to an outside payment page is a rejection risk
 * (App Store Review Guideline 3.1.1). A rejected build is a fix the divers
 * never receive, so the iOS build names the project website and nothing else.
 * Every other build - web, PWA, Android, desktop - carries the real
 * contribution page.
 *
 * Copyright (c) 2026 Eric Seigne <eric.seigne@cap-rel.fr>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

// Page collecting the contributions. Changing where the money is collected is
// a one-line change here, never a hunt through the views.
export const SUPPORT_URL = 'https://projets.cap-rel.fr/campaign/dba52c44a33f1ff526f20c86d5c42439'

// Project website, the only address an iOS build is allowed to show
export const PROJECT_URL = 'https://mvplan.org'

// Platform reported by Capacitor, 'web' outside of a native build
export function currentPlatform() {
  if (typeof window === 'undefined') return 'web'
  const platform = window.Capacitor?.getPlatform?.()
  return typeof platform === 'string' && platform !== '' ? platform : 'web'
}

// What the support screen shows here: the contribution page, or the project
// website on the builds where asking for money is not allowed.
export function supportTarget() {
  if (currentPlatform() === 'ios') {
    return { mode: 'website', url: PROJECT_URL }
  }
  return { mode: 'support', url: SUPPORT_URL }
}

// i18n key of the entry leading to that screen. The entry is named after what
// the screen really offers: an iOS entry labelled "support the project" would
// promise a contribution the screen cannot take.
export function supportEntryKey() {
  return supportTarget().mode === 'website' ? 'support_nav_website' : 'support_nav'
}
